const getApiRoot = () => {
  if (process.env.NODE_ENV === 'production') {
    return '/'
  }

  return process.env.VUE_APP_API_ROOT?.trim() || 'http://localhost:8000/'
}

export default getApiRoot
